module.exports = __webpack_public_path__ + "static/img/shuiBrandItem3.17fcbbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuiBrand/shuiBrandItem3.png
// module id = 3HAX
// module chunks = 0